// 15-minute time options for the receiving-hours pickers. Values are 24h
// "HH:mm"; labels are the 12h form drivers read.

export interface TimeOption {
  value: string;
  label: string;
}

export const formatTime = (hhmm: string): string => {
  const [hRaw, mRaw] = hhmm.split(':');
  const h = parseInt(hRaw, 10);
  const m = mRaw ?? '00';
  const period = h < 12 ? 'AM' : 'PM';
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${m.padStart(2, '0')} ${period}`;
};

export const TIME_OPTIONS: TimeOption[] = (() => {
  const options: TimeOption[] = [];
  for (let minutes = 0; minutes < 24 * 60; minutes += 15) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    options.push({ value, label: formatTime(value) });
  }
  return options;
})();
